module.exports = __webpack_public_path__ + "img/insights-new.903c1858.svg";